/* istanbul ignore file */
import { array as codecArray, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { IOTestInputCase } from './IOTestInputCase';
const IOTestBaseDataParser = /* #__PURE__ */ parsers.object([
    ['program', codecString],
    ['inputs', /* #__PURE__ */ codecArray(IOTestInputCase)],
]);
export class IOTestBaseData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return IOTestBaseDataParser.decode(input).map(res => new IOTestBaseData(res));
    }
    static unsafeDecode(input) {
        return IOTestBaseData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return IOTestBaseDataParser.encode(data);
    }
    static schema() {
        return IOTestBaseDataParser.schema();
    }
}
